module.exports = __webpack_public_path__ + "media/shortly.8313a847.mp4";